module.exports = __webpack_public_path__ + "static/img/rank_12.4550ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_12.png
// module id = z7jV
// module chunks = 0